<script>
    import { token } from "../../store";

    import { getContext } from "svelte";

    import { createForm } from "svelte-forms-lib";
    import axios from "axios";
    import * as yup from "yup";

    import Svelecte from "svelecte";
    import { dndzone } from "svelte-dnd-action";
    
    import { useQuery, useMutation  } from '@sveltestack/svelte-query';
    const profilData = useQuery("profilData");

    import {
        FormGroup,
        Label,
        Spinner
    } from 'sveltestrap';
    import Swal from 'sweetalert2';
    import twemoji from "twemoji";

    import { _ } from "svelte-i18n";

    let apiUrl = getContext("apiUrl");
    let postURL = apiUrl + 'ProfilUpdateInterest.php?token=' + $token;

    let result;

    let options = [
        {
            id: "Cinema",
            name: "Cinéma"
        },
        {
            id: "Travel",
            name: "Voyage"
        }
    ]
    
    function addUserCustomOptions(options, id) {
        const found = options.some(el => el.id === id);
        if (!found) options.push({ id: id, name: id});
        return options;
    }
        
    let interestsValue = [];
    
    if($profilData.data.interests){
        $profilData.data.interests.forEach((e) => {
            addUserCustomOptions(options, e.id);
            interestsValue.push(e.id)
        });
    }

    let mutation = useMutation(val => axios.post(postURL, val), {
        onSuccess: (data) => {
            result = data.data

            const Toast = Swal.mixin({
                toast: true,
                position: 'top-right',
                iconColor: 'white',
                customClass: {
                popup: 'colored-toast'
                },
                showConfirmButton: false,
                timer: 2500,
                timerProgressBar: true
            })

            if(result.success){
                window.navigator.vibrate(200);
                Toast.fire({
                    icon: 'success',
                    title: result.success
                })
            }

            if(result.error){
                Toast.fire({
                    icon: 'error',
                    title: result.error
                })
            }
        }
   });

    const { form, isSubmitting, handleSubmit, isValid } = createForm({
        initialValues: {
            interests : interestsValue
        },
        onSubmit: async values => {
            
            /*
            result = axios.post(postURL, values).then(function (response){
                    return response.data
            })*/

            return $mutation.mutate(values)
        },
    });
</script>

<form on:submit|preventDefault={handleSubmit} id="ProfilUpdate1" class="needs-validation" novalidate>
    <FormGroup>
        <Label for="interests">Intérêts</Label>
        <Svelecte 
            name="interests"
            {options}
            bind:value={$form.interests}
            clearable
            creatable
            multiple
            max=10
            {dndzone}
        ></Svelecte>
    </FormGroup>
    <FormGroup class="text-end">
        {#if $isSubmitting}
            <Spinner /> {$_("components.Forms.LoginForm.loading")}...
        {:else}
            <input type="submit" class="btn btn-outline-secondary" value="Modifier" disabled={!$isValid}/>
        {/if}
    </FormGroup>
</form>